import Pickr from '@simonwep/pickr';

const setupVideoEditListeners = () => {
  const video_allow_private = document.getElementById("video_allow_private")

  if (video_allow_private) {
    const link = document.getElementById("video_private_link")

    video_allow_private.addEventListener("change", (event) => {
      if (event.target.checked) {
        link.style.display = "block";
      } else {
        link.style.display = "none";
      }
    });
  }

  const video_preview_loop = document.getElementById("video_preview_loop")

  if (video_preview_loop) {
    const preview_loop = document.querySelectorAll(".video_preview_loop")

    video_preview_loop.addEventListener("change", (event) => {
      if (event.target.checked) {
        preview_loop.forEach(el => el.style.display = "flex");
      } else {
        preview_loop.forEach(el => el.style.display = "none");
      }
    });
  }

  const video_cta_show = document.getElementById("video_cta_show")

  if (video_cta_show) {
    const preview_loop = document.querySelectorAll(".video_cta_show")

    video_cta_show.addEventListener("change", (event) => {
      if (event.target.checked) {
        preview_loop.forEach(el => el.style.display = "flex");
      } else {
        preview_loop.forEach(el => el.style.display = "none");
      }
    });
  }

  const controlColors = document.getElementById("video_controls_color")
  if (controlColors) {
    const pickr = Pickr.create({
      el: document.getElementById("controls_color_picker"),
      theme: "nano",

      swatches: [
        'rgb(30, 113, 231)',
        'rgb(3, 169, 244)',
        'rgb(0, 188, 212)',
        'rgb(244, 67, 54)',
        'rgb(233, 30, 99)',
        'rgb(156, 39, 176)',
        'rgb(103, 58, 183)',
        'rgb(63, 81, 181)',
        'rgb(0, 150, 136)',
        'rgb(76, 175, 80)',
        'rgb(139, 195, 74)',
        'rgb(205, 220, 57)',
        'rgb(255, 235, 59)',
        'rgb(255, 193, 7)'
      ],

      components: {
        // Main components
        preview: true,
        opacity: false,
        hue: true,

        // Input / output Options
        interaction: {
          input: true,
          save: true
        }
      },

      strings: {
        save: "Enregistrer"
      }
    })

    pickr.on('init', pickr => {
      if (controlColors.value) {
        pickr.setColor(controlColors.value);
      }
    })

    pickr.on('save', color => {
      controlColors.value = color.toRGBA().toString(0);
      pickr.hide();
    })
  }
};

export { setupVideoEditListeners }
